// «Рынок → Розница → Tonusmeal»: подписи сетей и городов, выбор дня по умолчанию.
// Слова — в каталоге i18n; здесь только коды.

/** Сети Tonusmeal с подписью в каталоге (`prices.store.<код>`); незнакомая — кодом. */
const STORES = new Set(['5ka', 'auchan', 'globus', 'lenta', 'metro', 'perekrestok', 'magnit',
  'vkusvill'])

export function storeKey(code: string): string | null {
  return STORES.has(code) ? `prices.store.${code}` : null
}

/** Города «Рынка» (`ru_tonus.CITIES`, английское имя) с подписью в каталоге. */
const CITIES: Record<string, string> = {
  Moscow: 'moscow', 'Saint Petersburg': 'spb', Yekaterinburg: 'yekaterinburg',
  Novosibirsk: 'novosibirsk', Kazan: 'kazan', 'Nizhny Novgorod': 'nnovgorod',
  Chelyabinsk: 'chelyabinsk', Krasnoyarsk: 'krasnoyarsk', Samara: 'samara', Ufa: 'ufa',
  'Rostov-on-Don': 'rostov', Omsk: 'omsk', Krasnodar: 'krasnodar', Voronezh: 'voronezh',
  Perm: 'perm', Volgograd: 'volgograd', Vladivostok: 'vladivostok',
}

export function cityKey(city: string): string | null {
  return CITIES[city] ? `prices.city.${CITIES[city]}` : null
}

export interface ChainDay { city: string; day: string; points: number }

/** Города по числу точек за всё время, первый — самый наполненный. */
export function chainCities(days: ChainDay[]): string[] {
  const n = new Map<string, number>()
  for (const d of days) n.set(d.city, (n.get(d.city) ?? 0) + d.points)
  return [...n.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).map(([c]) => c)
}

/** Дни города, свежие первыми. */
export function chainDays(days: ChainDay[], city: string): string[] {
  return days.filter((d) => d.city === city).map((d) => d.day).sort().reverse()
}
